
import { makeRequest } from 'utils/requestLogger';

export default (id, payload) =>
    makeRequest('post', `/api/live_discussions/${id}/add_to_universe`, payload);


// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/addLiveDiscussionToUniverse.js